import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const ErrorMessage = styled.span`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.status.error.text};
`;
